import { ResponsiveBlockSwitcher } from "@/shared/Components";
import type { NewPasswordFormProps } from "../model";
import { Desktop, Mobile } from "./components";

export const NewPasswordForm = (props: NewPasswordFormProps) => {
  return (
    <ResponsiveBlockSwitcher mobile={<Mobile {...props} />} desktop={<Desktop {...props} />} />
  );
};
